<template>
  <!-- Footer -->
  <footer class="sticky-footer bg-white">
    <div class="container my-auto">
      <div class="copyright text-center my-auto">
        <span>Copyright &copy; Gouvernement du Bénin {{ new Date().getFullYear() }}</span>
      </div>
    </div>
  </footer>
  <!-- End of Footer -->
</template>

<script>
export default {
  name: "Footer",
};
</script>